import { DOM_NODE_ID } from '@/constants/general'
import AppBar from '@mui/material/AppBar'
import type { AppBarProps } from '@mui/material/AppBar'
import { styled } from '@mui/material/styles'

const domNode = document.getElementById(DOM_NODE_ID)
const railsEnv = domNode?.getAttribute('rails-env')

const ENV_BACKGROUNDS: Record<string, string> = {
    development: 'linear-gradient(0deg, #e0efd6 0%, #c6d8ff 100%)',
    alpha: 'linear-gradient(0deg, #e0efd6 0%, #ffe3e3 100%)',
    beta: 'linear-gradient(0deg, #e0efd6 0%, #fce8b9 100%)',
    demo: '#e0efd6',
    production: '#e0efd6',
}

const StyledAppBar = styled(AppBar)<AppBarProps>(({ theme }) => ({
    background: ENV_BACKGROUNDS[railsEnv ?? 'production'] ?? ENV_BACKGROUNDS.production,
    color: theme.palette.primary.main,
    boxShadow: 'none',
}))

export default StyledAppBar
